import { useFetch } from 'app/queryProvider';
import { TDeviceTutorialsResponse } from '../entities';

export const useDeviceTutorials = (pathwayId?: string, options?: { enabled?: boolean }) => {
  return useFetch<TDeviceTutorialsResponse>({
    queryKey: [['pathway', 'device-tutorials', pathwayId ?? '']],
    url: '/device-tutorials',
    resource: { name: 'pathways', id: pathwayId },
    options: {
      enabled: (options?.enabled ?? true) && !!pathwayId,
    },
  });
};
